// Action Types
import {
  UPDATE_NAVIGATION,
  PAGE_TRANSITION,
  UPDATE_FOOTER_USP,
  UPDATE_NAVIGATION_PANELS,
} from "./actions";

const initialState = {
  open: false, // BOOL: Primary Slide Open / Closed
  secondary: undefined, // STRING: Secondary Nav Slide Selected (ie "Women", "Men")
  scrolled: false,
  offset: 0,
  previousUrl: undefined,
  showFooterUSPNotice: false,
  panels: [null, null, null],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_NAVIGATION:
      return {
        ...state,
        ...action.navigation,
      };
    case PAGE_TRANSITION:
      return {
        ...state,
        previousUrl: action.previousUrl,
      };
    case UPDATE_FOOTER_USP:
      return {
        ...state,
        showFooterUSPNotice: action.showFooterUSPNotice,
      };
    case UPDATE_NAVIGATION_PANELS:
      return {
        ...state,
        panels: action.payload.panels,
      };
    default:
      return state;
  }
}
